import { useIsMobileDevice } from '@hivebrite/react-hooks';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';
import { useLiveFeedContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LiveFeedContext';
import getRailsType from 'hb-react/frontoffice/apps/LiveFeed/utils/getRailsType';
import Reactions from 'hb-react/frontoffice/components/Reactions';
import { amplitudeLogger } from 'hb-react/shared/utils/amplitude';

const Footer = () => {
  const {
    comments,
    displayCommentsByDefault,
    handleShare,
    id,
    itemUrl,
    lastContributors,
    likes,
    measure,
    onToggleComments,
    onTogglePostLike,
    onUpdateItem,
    originalType,
    shareUrl,
    totalComments,
    type,
  } = useLandingContext();
  const { amplitudeConfig } = useLiveFeedContext();
  const isMobileDevice = useIsMobileDevice();
  const amplitude = amplitudeLogger(amplitudeConfig);

  return (
    <Reactions
      comments={comments}
      displayCommentsByDefault={displayCommentsByDefault}
      handleShareButton={handleShare}
      id={id}
      key={id}
      initialLikes={likes}
      initialTotalComments={totalComments}
      isLikeModalFocusOnRef={!isMobileDevice}
      lastContributors={lastContributors}
      measure={measure}
      onCommentCallback={(newCommentsCount, newComments) => {
        // We only want to log added comments, not removed ones
        if (newCommentsCount > totalComments) {
          amplitude.track('LiveFeed|Commented', {
            landingType: type,
          });
        }

        if (onUpdateItem) {
          const newItem = {
            id,
            type: originalType,
            comments: newComments,
            total_comments: newCommentsCount,
          };

          onUpdateItem({ newItem, isItemPartial: true });
        }
      }}
      onToggleComments={onToggleComments}
      onTogglePostLike={onTogglePostLike}
      parentUrl={itemUrl}
      railsType={getRailsType(type)}
      shareUrl={shareUrl}
      type={type}
    />
  );
};

export default Footer;
